<template lang="pug">
  info-render(
    :full="value"
    :data="value[columnName]"
    :column="column"
    :minLength="column.minLength")
    template(slot-scope="props") {{ props.content }}
</template>

<script>
export default {
  props: {
    columnName: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    },
    column: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped lang="sass">
.text-value
  font-size: 16px
  color: #666
</style>



// WEBPACK FOOTER //
// SmartText.vue?7cf82ffc